import useCheckLoadedAndShowSPA from '../hooks/useCheckLoadedAndShowSPA';
import { execJsInSdk } from '../integration-utils';
var removeSocials = function () {
    return execJsInSdk(function () {
        ['a', 'button'].forEach(function (selector) {
            document.querySelectorAll(selector).forEach(function (x) {
                // @ts-ignore
                return x.innerText.match(/(google|twitter|passwordless)/i) && x.remove();
            });
        });
    });
};
export function useOnlyFans() {
    useCheckLoadedAndShowSPA(removeSocials);
}
